import React from "react";
import { formatDate, getIconByEvent } from "../../utils/helpers";
import { getFloorPlanActivityUrl } from "../../utils/floorPlanActivityUrl";

const PastActivityFloorPlanListView = ({ pastActivitiesData, render }) => {
  const planUrl = getFloorPlanActivityUrl(pastActivitiesData);

  const toggle = (item) => (
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        {getIconByEvent(item.typeTitle)}
        {item.plan_name}
      </div>
      <div className="toggle-date-time">
        {formatDate(item.activity_datetime || item.created_at)}
      </div>
    </div>
  );

  const collapse = (item) => (
    <ul className="noted-descr-body">
      <li>
        <label>ACTIVITY:</label>
        <span>{item.typeTitle}</span>
      </li>
      <li>
        <label>PLAN:</label>
        <span>{item.plan_name}</span>
      </li>
      <li>
        <label>URL:</label>
        <span>
          {planUrl ? (
            <a
              href={planUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {planUrl}
            </a>
          ) : (
            "———"
          )}
        </span>
      </li>
      {item.community?.name && (
        <li>
          <label>COMMUNITY:</label>
          <span>{item.community.name}</span>
        </li>
      )}
      {item.division?.name && (
        <li>
          <label>DIVISION:</label>
          <span>{item.division.name}</span>
        </li>
      )}
    </ul>
  );

  return render(toggle(pastActivitiesData), collapse(pastActivitiesData));
};

export default PastActivityFloorPlanListView;
